import { useNavigate } from 'react-router-dom';
import { Download, RefreshCw } from 'lucide-react';
import { useDesktopUpdateState } from './useDesktopUpdateState';

export default function DesktopUpdateBadge(): React.JSX.Element | null {
  const navigate = useNavigate();
  const state = useDesktopUpdateState();

  if (!state || !['downloading', 'ready', 'failed'].includes(state.status)) return null;
  const ready = state.status === 'ready';
  return (
    <button
      type="button"
      onClick={() => navigate('/update')}
      className="inline-flex items-center gap-1.5 rounded-full border border-[var(--lex-border)] px-2.5 py-1 text-xs font-medium text-[var(--lex-text-secondary)] hover:bg-[var(--lex-surface-hover)]"
      title="Open Update EdgeLex"
    >
      {ready ? <Download className="h-3.5 w-3.5" /> : <RefreshCw className={`h-3.5 w-3.5 ${state.status === 'downloading' ? 'animate-spin' : ''}`} />}
      {ready ? 'Restart to Update' : state.status === 'failed' ? 'Update Check Failed' : 'Updating EdgeLex'}
    </button>
  );
}
